import { Component, Input, Output, EventEmitter, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PubService, Publicite } from '../../services/Pub.service';
import { OrgconfService } from '../../services/orgconf.service';

interface UserData {
  idGuardian?: number;
  id?: number;
  photo?: string;
  nameGuardian: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {
  @Input() isOpen: boolean = true; // Open by default
  @Output() sidebarToggle = new EventEmitter<boolean>();

  isAdministrativeOpen: boolean = false;
  isCommunicationOpen: boolean = false;
  isUniversEnfantOpen: boolean = false;
  selectedRoute: string = ''; // Added to track the currently selected route

  isLanguageDropdownOpen: boolean = false;
  currentLanguage: string = 'en'; // Default language

  parentName: string = 'Utilisateur';
  parentPhoto: string = '../../../assets/acceuil/Icons/Profil Avatar.jpg';
  // show/hide menu entries based on organisation config
  showDelice: boolean = false;
  // Dynamic publicités for sidebar (always visible)
  sidebarAds: Publicite[] = [];

  constructor(
    private router: Router,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private pubService: PubService,
    private orgconf: OrgconfService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectedRoute = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit(): void {
    this.selectedRoute = this.router.url;
    this.currentLanguage = this.getSavedLanguage();
    this.translate.use(this.currentLanguage);
    this.loadParentData();

    // ensure we have fresh configuration each time the sidebar is initialized
    this.orgconf.refreshConfig().subscribe();
    this.orgconf.isDeliceEnabled().subscribe(enabled => {
      this.showDelice = enabled;
    });

    // Load two sidebar ads (page 1, size 2)
    this.pubService.getPublicites('Pubeducanet', 'SideBar', 1, 2).subscribe({
      next: (res: any) => {
       
        this.sidebarAds = res?.results?.articlePublicitaire || res || [];
        
        // Log each sidebar ad for detailed inspection
        this.sidebarAds.forEach(() => {
        });
      },
      error: (err) => {
        console.error('[SidebarComponent] Failed to load sidebar ads:', err);
        console.error('[SidebarComponent] SideBar error details:', {
          message: err.message,
          status: err.status,
          statusText: err.statusText,
          error: err.error
        });
        this.sidebarAds = [];
      }
    });
  }

  private loadParentData(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const userStr = localStorage.getItem('userData');
    if (userStr) {
      try {
        const userData: UserData = JSON.parse(userStr);
        if (userData.nameGuardian) {
          this.parentName = userData.nameGuardian;
        }

        if (userData.photo) {
          this.parentPhoto = `data:image/jpeg;base64,${userData.photo}`;
        }
      } catch (e) {
        console.error('Error parsing user data from localStorage', e);
      }
    }
  }

  toggleSidebar() {
    this.isOpen = !this.isOpen;
    this.sidebarToggle.emit(this.isOpen);
  }

  closeSidebar() {
    this.isOpen = false;
    this.sidebarToggle.emit(this.isOpen);
  }

  toggleCategory(category: string) {
    switch (category) {
      case 'administrative':
        this.isAdministrativeOpen = !this.isAdministrativeOpen;
        break;
      case 'communication':
        this.isCommunicationOpen = !this.isCommunicationOpen;
        break;
      case 'universEnfant':
        this.isUniversEnfantOpen = !this.isUniversEnfantOpen;
        break;
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  toggleLanguageDropdown() {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  selectLanguage(lang: string) {
    this.changeLanguage(lang);
    this.toggleLanguageDropdown();
  }

  changeLanguage(lang: string) {
    this.currentLanguage = lang;
    this.translate.use(lang);
    this.saveLanguage(lang);
  }

  getCurrentLanguageFlag(): string {
    switch (this.currentLanguage) {
      case 'en':
        return 'https://flagcdn.com/w20/gb.png';
      case 'fr':
        return 'https://flagcdn.com/w20/fr.png';
      case 'ar':
        return 'https://flagcdn.com/w20/tn.png';
      default:
        return 'https://flagcdn.com/w20/tn.png';
    }
  }

  private saveLanguage(lang: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('selectedLanguage', lang);
    }
  }

  private getSavedLanguage(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('selectedLanguage') || 'fr';
    }
    return 'fr';
  }


  onLogout() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
    this.router.navigate(['/']);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const clickedInsideLanguage = target.closest('.language-dropdown');
    const clickedInsideSidebar = target.closest('app-sidebar');

    if (!clickedInsideLanguage) {
      this.isLanguageDropdownOpen = false;
    }

    if (!clickedInsideSidebar && !this.isOpen) {
      this.closeSidebar();
    }
  }
}
